module.exports = "https://trybtryb-legacy.web.app/img/video.2b586fc9.svg";